import { useEffect, useState } from 'react';
import { useParams } from 'react-router';

import { getPublishHeroShot } from 'services/projects-heroshot.service';

export const usePublishHeroShot = () => {
  const params = useParams<{ id?: string }>();

  const [heroShot, setHeroShot] = useState('');

  useEffect(() => {
    const getHeroShot = async () => {
      if (!params.id) {
        setHeroShot('');
        return;
      }

      const shot = await getPublishHeroShot(params.id);
      if (shot) {
        setHeroShot(shot);
      }
    };

    getHeroShot();
  }, [params.id]);

  return heroShot;
};
